import {useMutation, UseMutationOptions, useQueryClient,} from '@tanstack/react-query';
import {GenerationResultDto} from '@tinct/core-api-models';
import {ApiError, tinctApi} from '../../api';

export interface RegenerateCampaignOnErrorParams {
  id: string;
  organizationId: string;
}

export const regenerateCampaignOnError = async (params: RegenerateCampaignOnErrorParams): Promise<GenerationResultDto> => {
  return await tinctApi.campaigns.regenerateOnError(params.id);
};

export const useRegenerateCampaignOnError = (
  options?: Omit<
    UseMutationOptions<GenerationResultDto, ApiError, RegenerateCampaignOnErrorParams>,
    'mutationFn'
  >,
) => {
  const { onSuccess, ...restOptions } = options || {};
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: regenerateCampaignOnError,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ['campaigns'] });
      queryClient.invalidateQueries({ queryKey: ['campaign', args[1].id] });
      queryClient.invalidateQueries({ queryKey: ['organization', args[1].organizationId] });
      onSuccess?.(...args);
    },
    ...restOptions,
  });
};
